module.exports = __webpack_public_path__ + "static/media/carpool_normal_blue_circle_white_w.6d14f150.png";